export default {
	"81eea5776173a422388a81ab72c494eb": "确认订单收银台-支付结果确认弹窗",
	"1444fb889c027d8288644d53f7003ffc": "等待支付…",
	"9cea2f350bb96b1a934cc871b4679f4b": "支付成功，去领取",
	"38e2bea31f0c67f23dcb0ef1a76e2037": "支付失败，重新支付"
}
